export default "__VITE_ASSET__BsKZpzXe__"